import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import {
	getFetchStock,
	getFetchCatalogImage,
	deleteCatalogImageById,
	getDropdownColor,
	getDropdownSize,
} from '../../../Redux/features/Stock/stockSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
	ACTUAL_IMAGE_URL,
	API_URL,
	COMPRESSED_IMAGE_URL,
	formConfig,
} from '../../../config/config';
import { ImCancelCircle } from 'react-icons/im';
import { MdOutlineEditNote } from 'react-icons/md';
import { DROPDOWN_FLAG } from '../../../config/config';
import { AiFillDelete } from 'react-icons/ai';
import { toast } from 'react-toastify';
import FilterSectionStoke from './FilterSectionForStoke';
import no_article from '../../images/no_product.png';
import { ImCross } from 'react-icons/im';
import { IoEye, IoAddCircle } from 'react-icons/io5';
import { MdImageNotSupported } from 'react-icons/md';

const Skeleton = () => (
	<>
		{/* Skeleton Rows */}
		{[...Array(8)].map((_, index) => (
			<tr key={index} className='w-full animate-pulse border'>
				<td className='py-1 px-4'>
					<div className=' w-16 h-16 bg-gray-300 rounded mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded  w-60 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className=''>
					<div className=' h-14 bg-gray-300 rounded w-14 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-3 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-36 mx-auto'></div>
				</td>
			</tr>
		))}
	</>
);

const compressImage = async (file) => {
	if (file.size <= 500 * 1024) {
		return file;
	}

	const img = document.createElement('img');
	img.src = URL.createObjectURL(file);
	await new Promise((resolve) => (img.onload = resolve));

	const canvas = document.createElement('canvas');
	const context = canvas.getContext('2d');
	const scale = 0.5;
	canvas.width = img.width * scale;
	canvas.height = img.height * scale;
	context.drawImage(img, 0, 0, canvas.width, canvas.height);

	return new Promise((resolve) => {
		canvas.toBlob(
			(blob) => {
				resolve(new File([blob], file.name, { type: file.type }));
			},
			file.type,
			1.0
		);
	});
};

function ManageCatalog() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [imageList, setImageList] = useState([]);
	const { allStock, totalPages } = useSelector((state) => state.stock);
	const [isTableLoading, setIsTableLoading] = useState(true);
	const [catalogImages, setCatalogImages] = useState([]);

	const [selectedProductId, setSelectedProductId] = useState(null);

	const [currentPage, setCurrentPage] = useState(1);

	const [Filter, setFilter] = useState({
		ArticleCode: '',
		MRP: 0,
		Category: '',
		Subcategory: '',
		Color: '',
		Size: '',
	});

	const [hasFetched, setHasFetched] = useState(false);

	useEffect(() => {
		const areFiltersEmpty = !Object.values(Filter).some(Boolean);

		if (allStock.length === 0 && !hasFetched && areFiltersEmpty) {
			setIsTableLoading(true);
			dispatch(getFetchStock({ page: currentPage, data: Filter })).then(() => {
				setIsTableLoading(false);
			});
			setHasFetched(true);
		} else {
			setIsTableLoading(false);
		}
	}, [dispatch, allStock.length, currentPage, Filter, hasFetched]);

	const [modal, setModal] = useState(false);

	const [imageDetails, setImageDetails] = useState({
		currentImage: '',
		ArticleCode: '',
		showImage: false,
	});

	const [fileName, setFileName] = useState(null);

	const [addMoreImgOpen, setAddMoreImgOpen] = useState(false);

	const ImageModal = (Id) => {
		setSelectedProductId(Id);
		setAddMoreImgOpen(true);
		dispatch(getFetchCatalogImage({ ProductId: Id })).then((response) => {
			setCatalogImages(response?.payload?.catalogImages);
		});
	};

	const [updateCatalog, setUdateCatalog] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	const UpdateModal = (Id) => {
		const filteredItem = allStock.find((item) => item.Id === Id);
		setSelectedItem(filteredItem);

		// Set the designData with the selected Id
		setDesignData((prev) => ({
			...prev,
			Id: filteredItem?.Id || '',
		}));

		setUdateCatalog(true);
	};

	const closeUpdateModal = () => {
		setUdateCatalog(false);
		setSelectedItem(null);
	};

	const handleDelete = async (Id) => {
		try {
			const response = await dispatch(deleteCatalogImageById(Id)).unwrap();

			if (response.success) {
				toast.success('Image deleted successfully!');

				dispatch(getFetchCatalogImage({ ProductId: selectedProductId })).then((response) => {
					setCatalogImages(response?.payload?.catalogImages);
				});
			} else {
				toast.error(response.message || 'Failed to delete image');
			}
		} catch (error) {
			toast.error('Error deleting image');
		}
	};

	const CloseImageModal = () => {
		setAddMoreImgOpen(false);
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			const newPage = currentPage + 1;
			setCurrentPage(newPage);
			dispatch(getFetchStock({ data: Filter, page: newPage }));
			navigate(`/manageCatalog/?page=${newPage}`);
		}
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			const newPage = currentPage - 1;
			setCurrentPage(newPage);
			dispatch(getFetchStock({ data: Filter, page: newPage }));
			navigate(`/manageCatalog/?page=${newPage}`);
		}
	};
	// Handle page number click
	const handlePageNumberClick = (page) => {
		if (page === currentPage) return;
		setCurrentPage(page);
		dispatch(getFetchStock({ page: page, data: Filter }));

		navigate(`/manageCatalog/?page=${page}`);
	};

	const generatePageNumbers = () => {
		const pages = [];
		const visiblePages = 5;

		if (totalPages <= visiblePages) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(i);
			}
		} else {
			pages.push(1);
			const startPage = Math.max(2, currentPage - 2);
			const endPage = Math.min(totalPages - 1, currentPage + 2);
			if (startPage > 2) {
				pages.push('...');
			}
			for (let i = startPage; i <= endPage; i++) {
				pages.push(i);
			}
			if (endPage < totalPages - 1) {
				pages.push('...');
			}
			pages.push(totalPages);
		}

		return pages;
	};

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file && file.size > 10 * 1024 * 1024) {
			// Show an error message
			toast.error('File size exceeds the 10MB limit. Please choose a smaller file.');

			return;
		}
		setFileName(file);
		setImageDetails((prevState) => ({
			...prevState,
			currentImage: URL.createObjectURL(file),
			showImage: true,
		}));
	};

	const handleCatalogImageChange = (e) => {
		const files = Array.from(e.target.files);

		const validFiles = files.filter((file) => file.size <= 10 * 1024 * 1024);

		if (validFiles.length < files.length) {
			toast.error('Some files exceeded the 10MB limit.');
		}

		const newImages = validFiles.map((file) => ({
			url: URL.createObjectURL(file),
			file,
		}));

		setImageList([...imageList, ...newImages]);
	};

	const removeCatalogImage = (index) => {
		setImageList(imageList.filter((_, i) => i !== index));
	};

	const handleCatalogSubmit = async () => {
		if (!selectedProductId) {
			toast.error('Product ID is missing. Please try again.');
			return;
		}

		if (imageList.length === 0) {
			toast.error('Please add images before submitting.');
			return;
		}

		const formData = new FormData();
		formData.append('ProductId', selectedProductId);

		imageList.forEach((img) => {
			formData.append(`CatalogueImages`, img.file);
		});

		try {
			const response = await axios.post(
				`${API_URL}/addStock/addCatalogImages`,
				formData,
				formConfig
			);

			if (response.data.success) {
				toast.success('Images uploaded successfully!');
				setImageList([]);

				dispatch(getFetchCatalogImage({ ProductId: selectedProductId })).then((response) => {
					setCatalogImages(response?.payload?.catalogImages);
				});
			} else {
				toast.error(response.data.message || 'Failed to upload images');
			}
		} catch (error) {
			console.error('Upload error:', error.response?.data || error.message);
			toast.error(error.response?.data?.message || 'An error occurred while uploading.');
		}
	};

	const handleSubmit = async (Id) => {
		if (!fileName) return console.error('No image selected');

		const compressedImage = await compressImage(fileName);

		const uploadData = new FormData();
		uploadData.append('originalImage', fileName);
		uploadData.append('compressedImage', compressedImage);
		uploadData.append('Id', Id);

		try {
			const response = await axios.post(
				`${API_URL}/addStock/updateThumbnailImage`,
				uploadData,
				formConfig
			);

			if (response.data.success === true) {
				dispatch(getFetchStock({ page: currentPage, data: Filter }));
				handlecloseModal();
				toast.success(`Product image ${response.data.message}`);
			} else if (response.data.success === false) {
			}
		} catch (error) {
			toast.error(error.response.data.message);
		}
	};

	const handleReset = () => {
		setFilter({
			ProductId: 0,
			MRP: 0,
			Category: '',
			IsDisplayOnPortal: '',
		});
		dispatch(getFetchStock({ page: 1 }));
		setCurrentPage(1);
	};

	const handleStokeFilter = () => {
		setCurrentPage(1);
		getFetchStock(1);
		dispatch(getFetchStock({ data: Filter, page: 1 }));
	};

	// Image change modal
	const handleImageClick = (image, Id) => {
		setImageDetails({
			currentImage: image,
			Id: Id,
		});
		setModal(true);
	};

	const handlecloseModal = () => {
		setImageDetails({
			currentImage: '',
			Id: '',
		});
		setModal(false);
	};

	// update stock detail
	const [filteredColorOptions, setFilteredColorOptions] = useState([]);
	const { Color } = useSelector((state) => state.stock);
	const [showColorDropdown, setShowColorDropdown] = useState(false);
	const [shouldShowAddNewColor, setShouldShowAddNewColor] = useState(false);
	const [filteredSizeOptions, setFilteredSizeOptions] = useState([]);
	const { Size } = useSelector((state) => state.stock);
	const [showSizeDropdown, setShowSizeDropdown] = useState(false);
	const [shouldShowAddNewSize, setShouldShowAddNewSize] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const [designData, setDesignData] = useState({
		Id: null,
		Color: selectedItem?.Color || '',
		Size: selectedItem?.Size || '',
		Qty: selectedItem?.Qty || 0,
		MRP: selectedItem?.MRP || 0,
		Discount: selectedItem?.Discount || 0,
		DiscountMRP: selectedItem?.DiscountMRP || 0,
		DiscountType: selectedItem?.DiscountType || '',
		UserId: 1,
	});

	const [DropdownData, setDropdownData] = useState({
		MasterType: '',
		MasterValue: '',
	});

	useEffect(() => {
		if (selectedItem) {
			setDesignData((prevState) => ({
				...prevState,
				Color: selectedItem?.Color || prevState.Color,
				Size: selectedItem?.Size || prevState.Size,
				Qty: selectedItem?.Qty || prevState.Qty,
				MRP: selectedItem?.MRP || prevState.MRP,
				Discount: selectedItem?.Discount || prevState.Discount,
				DiscountMRP: selectedItem?.DiscountMRP || prevState.DiscountMRP,
				DiscountType: selectedItem?.DiscountType || prevState.DiscountType,
			}));
		}
	}, [selectedItem]);

	const handleColorChange = (e) => {
		const value = e.target.value;
		setDesignData({ ...designData, Color: value });

		const filtered = Color.filter((c) => c.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredColorOptions(filtered);

		setShouldShowAddNewColor(
			value.trim() !== '' &&
				!filtered.some((c) => c.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowColorDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectColor = (c) => {
		setDesignData({ ...designData, Color: c.MasterValue });
		setFilteredColorOptions([]);
		setShowColorDropdown(false);
	};

	const handleSizeChange = (e) => {
		const value = e.target.value;
		setDesignData({ ...designData, Size: value });

		const filtered = Size.filter((s) => s.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredSizeOptions(filtered);

		setShouldShowAddNewSize(
			value.trim() !== '' &&
				!filtered.some((s) => s.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowSizeDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectSize = (s) => {
		setDesignData({ ...designData, Size: s.MasterValue });
		setFilteredSizeOptions([]);
		setShowSizeDropdown(false);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (!/^\d{0,5}$/.test(value) && (name === 'MRP' || name === 'Discount' || name === 'Qty')) {
			return; // Do not allow invalid input
		}
		setDesignData((prevData) => {
			const updatedData = {
				...prevData,
				[name]: value,
			};

			// If MRP or Discount changes, perform the logic calculation
			if (name === 'Discount' || name === 'MRP' || name === 'DiscountType') {
				const mrpValue = parseFloat(updatedData.MRP) || 0;
				let discountValue = parseFloat(updatedData.Discount) || 0;

				if (updatedData.DiscountType === 'P') {
					// Convert percentage to rupees
					discountValue = (discountValue / 100) * mrpValue;
				}

				// Ensure discount is not more than MRP
				if (discountValue > mrpValue) {
					toast.error('Discount cannot be greater than MRP.');
					discountValue = mrpValue; // Set it to MRP to avoid negative values
				}

				// Calculate DiscountMRP
				updatedData.DiscountMRP = mrpValue - discountValue;
			}

			return updatedData;
		});
	};

	useEffect(() => {
		if (Color.length === 0 && !hasFetched) {
			dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
			setHasFetched(true);
		}
	}, [dispatch, Color, hasFetched]);

	useEffect(() => {
		if (Size.length === 0 && !hasFetched) {
			dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
			setHasFetched(true);
		}
	}, [dispatch, Size, hasFetched]);

	const handleModal = (masterType) => {
		setDropdownData({
			MasterType: masterType,
			MasterValue: '',
		});
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
		setDropdownData({
			MasterType: '',
			MasterValue: '',
		});
	};

	const handleDropdownChange = (e) => {
		const { name, value } = e.target;
		const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

		setDropdownData((prevData) => ({
			...prevData,
			[name]: formattedValue,
		}));
	};

	const handleSubmitDropdown = async (e) => {
		e.preventDefault();

		if (!DropdownData.MasterType || !DropdownData.MasterValue) {
			return toast.error('Please fill in all fields.');
		}

		const uploadData = new FormData();
		uploadData.append('MasterType', DropdownData.MasterType);
		uploadData.append('MasterValue', DropdownData.MasterValue);

		const data = {
			MasterType: DropdownData.MasterType,
			MasterValue: DropdownData.MasterValue,
		};

		try {
			const response = await axios.post(`${API_URL}/addStock/addDropdown`, data, formConfig);
			if (response?.data?.success) {
				if (DropdownData.MasterType === 4) {
					dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
				} else if (DropdownData.MasterType === 7) {
					dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
				}

				toast.success(response?.data?.message);
				setDropdownData({ MasterType: '', MasterValue: '' });

				handleCloseModal();
			} else {
				toast.error(response?.data?.message || 'Unexpected error.');
			}
		} catch (error) {
			toast.error(error?.response?.data?.message || 'An error occurred.');
		}
	};

	const handleUpdateDesign = async (e) => {
		try {
			e.preventDefault();

			const update = new FormData();
			update.append('Id', designData.Id);
			update.append('Color', designData.Color);
			update.append('Size', designData.Size);
			update.append('Qty', designData.Qty);
			update.append('MRP', designData.MRP);
			update.append('Discount', designData.Discount);
			update.append('DiscountMRP', designData.DiscountMRP);
			update.append('DiscountType', designData.DiscountType);
			update.append('UserId', designData.UserId);

			const response = await axios.post(
				`${API_URL}/addStock/updateStockDetailData`,
				update,
				formConfig
			);

			if (response.data.success) {
				setDesignData({
					Id: '',
					Color: '',
					Size: '',
					Qty: '',
					MRP: '',
					Discount: '',
					DiscountMRP: '',
					DiscountType: '',
					UserId: '',
				});
				toast.success(`${designData.Id} Added to Stock Successfully`);

				setTimeout(() => {
					setUdateCatalog(false);
				}, 100);
				setDesignData({
					Id: '',
					Color: '',
					Size: '',
					Qty: '',
					MRP: '',
					Discount: '',
					DiscountMRP: '',
					DiscountType: '',
					UserId: '',
				});
				dispatch(getFetchStock({ page: currentPage, data: Filter }));
			}
		} catch (error) {
			toast.error(error?.response?.data?.message || 'Something went wrong.');
		}
	};

	return (
		<>
			<div className='p-6'>
				{/* Search Inputs */}
				{/* <div className="flex mb-4 gap-4">...Search form elements</div> */}
				{/* Search Bar */}
				<FilterSectionStoke
					Filter={Filter}
					currentPath={'/manageCatalog'}
					setFilter={setFilter}
					handleStokeFilter={handleStokeFilter}
					handleReset={handleReset}
				/>
				<div className='overflow-x-auto'>
					<table className='min-w-full bg-white table-auto lg:text-base text-sm max-[400px]:text-xs '>
						<thead>
							<tr className='w-full bg-gray-100'>
								<th className='py-1 px-4'>S.No</th>
								<th className='py-1 px-4'>Article Code</th>
								<th className='py-1 px-4'>Category</th>
								<th className='py-1 px-4'>Sub-Category</th>
								<th className='py-1 px-4'>Thumbnail</th>
								<th className='py-3 px-4'>Color</th>
								<th className='py-3 px-4'>Size</th>
								<th className='py-3 px-4'>MRP</th>
								<th className='py-3 px-4'>Discount</th>
								<th className='py-3 px-4'>Discount MRP</th>
								<th className='py-3 px-4'>Stock Qty</th>
								<th className='py-3 px-4'>Catalog Images</th>
								<th className='py-3 px-4'>Edit Catalog</th>
							</tr>
						</thead>
						<tbody>
							{isTableLoading ? (
								<Skeleton />
							) : (
								allStock?.map((item, index) => (
									<tr key={index} className='border-b'>
										<td className='py-3 px-4 text-center'>{item.Id}</td>
										<td className='py-3 px-4 text-center'>{item.ArticleCode}</td>
										<td className='py-3 px-4 text-center'>{item.Category}</td>
										<td className='py-3 px-4 text-center'>{item.SubCategory}</td>
										<td className='flex justify-center items-center p-2'>
											<img
												src={`${COMPRESSED_IMAGE_URL}/${item.ImagePath}`}
												// src={`${ACTUAL_IMAGE_URL}/${item.ImagePath}`}
												alt={item.ArticleCode}
												className='w-16 h-16 object-cover cursor-pointer'
												onClick={() => handleImageClick(item.ImagePath, item.Id)}
											/>
										</td>

										<td className='py-3 px-4 text-center'>{item.Color}</td>
										<td className='py-3 px-4 text-center'>{item.Size}</td>
										<td className='py-3 px-4 text-center'>
											<span className='font-serif'>₹</span>
											{item.MRP}
										</td>
										<td className='py-3 px-4 text-center'>
											{item.DiscountType === 'R' ? (
												<>
													<span className='font-serif'>₹</span>
													{item.Discount}
												</>
											) : item.DiscountType === 'P' ? (
												<>
													{item.Discount}
													<span>%</span>
												</>
											) : (
												item.Discount
											)}
										</td>

										<td className='py-3 px-4 text-center'>
											<span className='font-serif'>₹</span>
											{item.DiscountMRP}
										</td>
										<td className='py-3 px-4 text-center'>{item.Qty}</td>
										<td className=' '>
											<div className='flex justify-center items-center gap-5 w-full'>
												<button
													onClick={() => ImageModal(item?.Id)}
													className='text-blue-500 text-2xl flex flex-row justify-center items-center gap-2'>
													<IoEye />
												</button>
											</div>
										</td>
										<td className='py-3 px-4 text-center'>
											<div className='flex justify-center items-center gap-5 w-full'>
												<button
													onClick={() => UpdateModal(item?.Id)}
													className='text-red-400 text-4xl  flex flex-row justify-center items-center gap-2'>
													<MdOutlineEditNote />
												</button>
											</div>
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
					{allStock?.length === 0 && (
						<div className='flex flex-col justify-center items-center'>
							<img
								src={no_article}
								alt='Empty Cart'
								className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
							/>
						</div>
					)}
				</div>

				{/* {isImageLoading && (
					<div className='fixed inset-0  flex justify-center items-center z-50'>
						<div class='w-16 h-16 border-4 border-t-red-500 border-gray-300 rounded-full animate-spin'></div>
					</div>
				)} */}

				{addMoreImgOpen && (
					<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
						<div className='bg-white py-4 px-5 rounded-md   relative'>
							<button
								onClick={() => CloseImageModal(false)}
								className=' z-10 absolute right-0 top-0 md:w-20 md:h-20 w-16 h-16 rounded-tr-md rounded-bl-full shadow-xl bg-red-500 hover:bg-red-600 transition-colors duration-300 text-center'>
								<ImCross className='text-white absolute md:right-5 right-4 md:text-lg text-base md:top-5 top-4 text-center' />
							</button>
							<h2 className='text-xl font-semibold'> Catalog Images</h2>
							<div className=' border-[1px] border-black mb-3 sm:w-12 w-10 ' />
							<div className=' max-h-[600px] overflow-y-auto p-2 max-w-5xl custom-scrollbar'>
								<div className='flex flex-wrap justify-start gap-2 '>
									{catalogImages && catalogImages.length > 0 ? (
										catalogImages?.map((img, index) => (
											<div key={index} className='relative group'>
												<img
													src={`${COMPRESSED_IMAGE_URL}/${img.CatalogueImagePath}`}
													alt='Product'
													className='w-[250px] md:w-[180px] lg:w-[320px] rounded-sm object-cover'
												/>
												<button
													onClick={() => handleDelete(img.Id)}
													className='absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
													<div className='relative group/icon'>
														<AiFillDelete className='text-red-500 text-2xl hover:text-red-600' />
														{/* Tooltip - Appears only on icon hover */}
														<span className='absolute top-6 right-0 bg-black bg-opacity-70 font-medium text-white text-xs px-2 py-1 rounded-md opacity-0 group-hover/icon:opacity-100 transition-opacity duration-300 whitespace-nowrap'>
															Want to delete this image?
														</span>
													</div>
												</button>
											</div>
										))
									) : (
										<div className=' flex justify-center items-center flex-col w-full'>
											<MdImageNotSupported className='text-8xl text-red-400' />
											<p>No Images available</p>
										</div>
									)}
								</div>
								<div className=' border-b border-gray-400 border-opacity-50 mt-3' />
								{imageList.length > 0 && (
									<>
										<div className='mt-4 overflow-x-auto custom-scrollbar'>
											<div className='flex space-x-4 p-2 rounded-md'>
												{imageList?.map((img, index) => (
													<div
														key={index}
														className='border p-2 rounded-md flex flex-col items-center'>
														<p className='text-sm font-semibold'>#{index + 1}</p>
														<img
															src={img.url}
															alt=''
															className=' w-32 h-32 object-cover rounded '
														/>
														<button
															onClick={() => removeCatalogImage(index)}
															className='mt-2 bg-red-500 text-white px-2 py-1 w-full text-xs rounded-md'>
															<span className=' flex justify-between items-center gap-2'>
																<span className=' font-medium'>Remove</span>
																<AiFillDelete className=' text-base' />
															</span>
														</button>
													</div>
												))}
											</div>
										</div>
										<button
											onClick={handleCatalogSubmit}
											className='mt-3 ml-3  w-32 proBtn rounded-md'>
											Submit
										</button>
									</>
								)}
								<div className=' flex flex-col mt-4'>
									<label className=' ml-2 text-sm font-medium'> Add New Catalog Images</label>
									<input
										type='file'
										accept='image/*'
										multiple
										onChange={handleCatalogImageChange}
										className=' mt-1 w-full border p-2 rounded-md'
									/>
								</div>
							</div>
						</div>
					</div>
				)}

				{/* Pagination */}
				<div className=' flex justify-center items-center flex-row mt-5 gap-2 '>
					{currentPage > 1 && (
						<button
							onClick={handlePrevPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronLeft />
						</button>
					)}

					<div className='space-x-2'>
						{generatePageNumbers().map((page, index) =>
							typeof page === 'number' ? (
								<button
									key={index}
									onClick={() => handlePageNumberClick(page)}
									className={`px-3 py-1 border rounded text-base font-semibold ${
										page === currentPage
											? 'bg-[#EF4444] text-white'
											: 'bg-gray-200 hover:bg-gray-300'
									}`}>
									{page}
								</button>
							) : (
								<span key={index} className='text-gray-500'>
									...
								</span>
							)
						)}
					</div>

					{currentPage < totalPages && (
						<button
							onClick={handleNextPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronRight />
						</button>
					)}
				</div>
			</div>

			{modal && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white py-4 px-5 rounded-md  w-[310px] md:w-[220px] lg:w-[350px] relative'>
						<ImCancelCircle
							onClick={handlecloseModal}
							className='text-red-500 absolute top-1 right-2 text-[32px] font-bold cursor-pointer'
						/>
						{!imageDetails.showImage && (
							<div className='flex items-center justify-center'>
								<img
									// src={`${COMPRESSED_IMAGE_URL}/${imageDetails.currentImage}`}
									src={`${ACTUAL_IMAGE_URL}/${imageDetails.currentImage}`}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:w-[320px] object-cover'
								/>
							</div>
						)}
						{imageDetails.showImage && (
							<div className='flex items-center justify-center flex-col'>
								<img
									src={imageDetails.currentImage}
									alt='Stock'
									className='w-[250px] md:w-[180px] lg:[320px] object-cover'
								/>
							</div>
						)}
						<div className='lg:mt-5 mt-2 flex flex-col  items-center justify-center gap-2'>
							<input
								type='file'
								accept='image/*'
								onChange={handleImageChange}
								placeholder='Enter'
								className=' w-[250px] md:w-[180px] lg:[320px] object-cover'
							/>
							<button
								onClick={() => handleSubmit(imageDetails.Id)}
								className='w-full  text-white bg-red-500 px-3 py-2 font-semibold text-sm rounded-md'>
								Save
							</button>
						</div>
					</div>
				</div>
			)}

			{showModal && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-md w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] relative'>
						<ImCancelCircle
							onClick={handleCloseModal}
							className='text-red-500 absolute right-3 top-3 text-2xl font-bold cursor-pointer'
						/>
						<form onSubmit={handleSubmitDropdown}>
							<div className='mt-3'>
								<input
									type='text'
									name='MasterValue'
									value={DropdownData.MasterValue}
									onChange={handleDropdownChange}
									className='w-full bg-gray-100 text-gray-900 mt-3 mb-4 p-3 focus:shadow-outline border-[0.25px] rounded-md'
									placeholder='Enter New Dropdown Value'
								/>
							</div>
							<div className='mt-4 flex justify-end'>
								<button
									type='submit'
									className='w-full sm:w-auto text-white bg-red-500 px-4 py-3 font-semibold text-sm rounded-md'>
									Save
								</button>
							</div>
						</form>
					</div>
				</div>
			)}

			{updateCatalog && selectedItem && (
				<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-30'>
					<div className='bg-white py-4 px-5 rounded-md relative '>
						<button
							onClick={closeUpdateModal}
							className='z-10 absolute right-0 top-0 md:w-20 md:h-20 w-16 h-16 rounded-tr-md rounded-bl-full shadow-xl bg-red-500 hover:bg-red-600 transition-colors duration-300 text-center'>
							<ImCross className='text-white absolute md:right-5 right-4 md:text-lg text-base md:top-5 top-4 text-center' />
						</button>
						<h2 className='text-xl font-semibold  '>Update Catalog</h2>
						<div className='border-[1px] border-black mb-3 sm:w-12 w-10' />

						<div className='p-2 w-full max-w-4xl'>
							<table className='w-full border-collapse text-sm md:text-base overflow-x-auto'>
								<thead>
									<tr className=' bg-gray-100'>
										<th className='p-2'>Color</th>
										<th className='p-2'>Size</th>
										<th className='p-2'>MRP</th>
										<th className='p-2'>Discount</th>
										<th className='p-2'>Discount MRP</th>
										<th className='p-2'>Stock Qty</th>
									</tr>
								</thead>
								<tbody>
									<tr className=''>
										<td className='p-2 text-center'>{selectedItem.Color}</td>
										<td className='p-2 text-center'>{selectedItem.Size}</td>
										<td className='p-2 text-center'>
											<span className='font-serif'>₹</span>
											{selectedItem.MRP}
										</td>
										<td className='p-2 text-center'>
											{selectedItem.DiscountType === 'R' ? (
												<>
													<span className='font-serif'>₹</span>
													{selectedItem.Discount}
												</>
											) : selectedItem.DiscountType === 'P' ? (
												<>
													{selectedItem.Discount}
													<span>%</span>
												</>
											) : (
												selectedItem.Discount
											)}
										</td>
										<td className='p-2 text-center'>
											<span className='font-serif'>₹</span>
											{selectedItem.DiscountMRP}
										</td>
										<td className='p-2 text-center'>{selectedItem.Qty}</td>
									</tr>
								</tbody>
							</table>
							<form onSubmit={handleUpdateDesign} className=' max-md:h-96 overflow-y-auto'>
								<div className='shadow-md border px-4 md:px-10 py-5 rounded-md'>
									<p className=' font-medium text-lg md:text-xl mb-1 text-center'>Update Designs</p>
									<div className=' border-[1px] border-black sm:mb-8 mb-6 sm:w-12 w-10 ' />
									<div className='grid grid-cols-1 gap-6 mb-6'>
										<div className=' flex md:flex-row flex-col w-full gap-4'>
											<div className='flex flex-col relative w-full'>
												<label className='text-sm font-medium mb-1'>Color</label>
												<div className=' flex flex-row  items-center'>
													<div className=' w-full'>
														<input
															name='Color'
															type='text'
															className='border rounded p-2 w-full'
															placeholder='Search Color'
															value={designData.Color}
															onChange={handleColorChange}
															autoComplete='off'
														/>
													</div>
													<div className='relative inline-block group'>
														{/* Button with hover effect */}
														<button
															type='button'
															onClick={() => handleModal(4)} // Correctly wrapped
															className=''>
															<IoAddCircle className=' text-[44px] hover:text-green-600 text-green-500' />
														</button>

														{/* Tooltip that appears on hover */}
														<div className='absolute md:top-[40px] z-20 max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
															Add New Color
														</div>
													</div>
												</div>
												{showColorDropdown && designData?.Color?.trim() !== '' && (
													<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
														{filteredColorOptions.length > 0 ? (
															filteredColorOptions.map((c) => (
																<div
																	key={c.MasterValue}
																	className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																	onClick={() => selectColor(c)}>
																	{c.MasterValue}
																</div>
															))
														) : (
															<div className='z-0'></div>
														)}

														{shouldShowAddNewColor && (
															<div
																className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																onClick={() => handleModal(4)}>
																+ Add this as new color: &quot;{designData.Color}&quot;
															</div>
														)}
													</div>
												)}
											</div>

											<div className='flex flex-col relative w-full'>
												<label className='text-sm font-medium mb-1'>Size:</label>
												<div className=' flex flex-row  items-center'>
													<div className=' w-full'>
														<input
															type='text'
															name='Size'
															className='border rounded p-2 w-full'
															placeholder='Search Size'
															value={designData.Size}
															onChange={handleSizeChange}
															autoComplete='off'
														/>
													</div>
													<div className='relative inline-block group'>
														<button type='button' onClick={() => handleModal(7)} className=''>
															<IoAddCircle className='text-[44px] hover:text-green-600 text-green-500' />
														</button>

														<div className='absolute z-20 md:top-[40px] max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
															Add New Size
														</div>
													</div>
												</div>

												{showSizeDropdown && designData?.Size?.trim() !== '' && (
													<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
														{filteredSizeOptions.length > 0 ? (
															filteredSizeOptions.map((s) => (
																<div
																	key={s.MasterValue}
																	className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																	onClick={() => selectSize(s)}>
																	{s.MasterValue}
																</div>
															))
														) : (
															<div className='z-0'></div>
														)}

														{shouldShowAddNewSize && (
															<div
																className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
																onClick={() => handleModal(7)}>
																+ Add this as new Size: &quot;{designData.size}&quot;
															</div>
														)}
													</div>
												)}
											</div>

											<div className=' flex flex-row w-full gap-4'>
												<div className=' flex flex-col w-full'>
													<label className='text-sm font-medium mb-1'>Quantity:</label>
													<input
														type='text'
														name='Qty'
														value={designData.Qty}
														onChange={handleChange}
														className='border rounded p-2 w-full'
														placeholder=' Enter Quantity'
													/>
												</div>
											</div>
										</div>
										<div className=' flex md:flex-row flex-col w-full gap-4'>
											<div className='flex flex-col w-full'>
												<label className='text-sm font-medium mb-1'>Price:</label>
												<input
													name='MRP'
													value={designData.MRP}
													onChange={handleChange}
													type='number'
													className='border rounded p-2 w-full'
													placeholder='Enter Price'
												/>
											</div>

											<div className='flex flex-col w-full'>
												<label className='text-sm font-medium mb-1'>Discount:</label>
												<input
													type='number'
													name='Discount'
													value={designData.Discount}
													onChange={handleChange}
													className='border rounded p-2 w-full'
													placeholder='Enter Discount'
												/>
											</div>
											<div className='flex flex-col w-full'>
												<label className='text-sm font-medium mb-1'>Discount:</label>

												<select
													name='DiscountType'
													value={designData.DiscountType}
													onChange={handleChange}
													className='border rounded p-2 w-full bg-white font-serif'>
													<option value=''>Select Discount Type</option>
													<option value='P'>Percentage (%) </option>
													<option value='R'>Rupees (₹)</option>
												</select>
											</div>

											<div className='flex flex-col w-full'>
												<label className='text-sm font-medium mb-1'>Discount MRP:</label>
												<input
													type='text'
													name='DiscountMRP'
													value={designData.DiscountMRP}
													className='border rounded p-2 w-full'
													placeholder='Discount MRP'
													readOnly
												/>
											</div>
										</div>
										<button className=' mt-2 proBtn rounded-md w-36' type='submit'>
											Update
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default ManageCatalog;
